module.exports = __webpack_public_path__ + "static/media/Stellar Vox Queen Headboard - 155 cm.b93eb7f6.jpg";